import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "../../components/NetworkGraph";
import Reveal from "../../components/Reveal";
import { IconMonitor, IconPrinter } from "../../components/Icons";

const FAQS = [
  {
    question: "Preciso comprar os equipamentos ao final do contrato?",
    answer:
      "Não. Nos modelos de outsourcing e locação, os equipamentos pertencem à sepolTECH durante todo o contrato. Ao encerrar, os equipamentos são recolhidos. Se desejar adquirir ao final do período, há opção de compra com condições especiais.",
  },
  {
    question:
      "Qual a diferença entre outsourcing de TI e suporte técnico avulso?",
    answer:
      "No suporte avulso, você paga por chamado ou hora trabalhada. No outsourcing, você paga uma mensalidade fixa e tem toda a TI gerenciada proativamente — os equipamentos já estão incluídos. É uma TI completa como serviço, sem surpresas no final do mês.",
  },
  {
    question: "O toner da impressora locada está incluso?",
    answer:
      "Sim. No plano de locação de impressoras, toner, peças e manutenção estão todos incluídos na mensalidade. A reposição de toner é monitorada e enviada automaticamente antes de acabar, sem nenhum custo adicional para você.",
  },
  {
    question: "Posso contratar outsourcing de TI e locação de impressora juntos?",
    answer:
      "Sim, e é exatamente assim que a maioria dos nossos clientes faz. Contratar os dois serviços juntos garante desconto e a vantagem de ter toda a infraestrutura — computadores e impressoras — gerenciada por uma única empresa, com um único ponto de contato.",
  },
  {
    question: "Qual é o prazo mínimo de contrato?",
    answer:
      "Os contratos têm prazo mínimo de 12 meses, com opções de 24 e 36 meses com desconto progressivo. Fale com nossa equipe comercial para montar o contrato ideal para o tamanho e necessidade da sua empresa.",
  },
];

const COMPARE_CARDS = [
  {
    accent: "#E8530A",
    glow: "rgba(232,83,10,.15)",
    Icon: IconMonitor,
    tag: "Outsourcing de TI",
    title: (
      <>
        Terceirização
        <br />
        de Infraestrutura
      </>
    ),
    desc: (
      <>
        A sepolTECH fornece e gerencia os{" "}
        <strong style={{ color: "var(--text-primary)" }}>
          computadores, notebooks e periféricos
        </strong>{" "}
        da sua empresa. Você paga uma mensalidade fixa e recebe os
        equipamentos configurados, monitorados e com suporte técnico
        completo — sem precisar comprar hardware.
      </>
    ),
    bullets: [
      {
        title: "Equipamentos fornecidos",
        desc: "PCs, notebooks, monitores e periféricos sem desembolso de capital",
      },
      {
        title: "Configuração e gestão",
        desc: "instalação de SO, softwares, políticas de segurança e atualizações",
      },
      {
        title: "Suporte técnico incluído",
        desc: "atendimento remoto e presencial via sepolTECH",
      },
      {
        title: "Substituição garantida",
        desc: "equipamento com defeito trocado sem custo extra",
      },
      {
        title: "Monitoramento 24/7",
        desc: "via RMM com alertas proativos antes de falhas",
      },
    ],
    note: "empresas que querem eliminar gastos imprevistos com hardware e ter toda a TI gerenciada por mensalidade fixa.",
  },
  {
    accent: "#FF6B35",
    glow: "rgba(255,107,53,.15)",
    Icon: IconPrinter,
    tag: "Locação de Impressoras",
    title: (
      <>
        Impressão sem
        <br />
        preocupação
      </>
    ),
    desc: (
      <>
        A sepolTECH fornece a{" "}
        <strong style={{ color: "var(--text-primary)" }}>impressora multifuncional</strong>{" "}
        e cuida de tudo: toner, manutenção, peças e suporte técnico. Você
        paga por página impressa ou por mensalidade fixa — nunca mais se
        preocupa com suprimentos ou assistência técnica.
      </>
    ),
    bullets: [
      {
        title: "Equipamento fornecido",
        desc: "impressoras laser mono ou colorida, multifuncional",
      },
      {
        title: "Toner e suprimentos incluídos",
        desc: "reposição automática sem custo adicional",
      },
      {
        title: "Manutenção preventiva e corretiva",
        desc: "peças e mão de obra sem custo extra",
      },
      {
        title: "Instalação e configuração",
        desc: "rede, wi-fi, digitalização e drivers em todos os PCs",
      },
      {
        title: "Contagem de páginas",
        desc: "controle de impressões com relatório mensal",
      },
    ],
    note: "empresas com alto volume de impressão que querem previsibilidade de custos e zero dor de cabeça com equipamento ou toner.",
  },
];

const TABLE_ROWS = [
  {
    label: "O que é fornecido",
    outsourcing: { text: "PCs, notebooks, periféricos", color: "var(--text-primary)" },
    locacao: { text: "Impressoras multifuncionais", color: "var(--text-primary)" },
    alt: false,
  },
  {
    label: "Suprimentos incluídos",
    outsourcing: { text: "—", color: undefined },
    locacao: { text: "✓ Toner e peças", color: "#FF6B35" },
    alt: true,
  },
  {
    label: "Gestão de software",
    outsourcing: { text: "✓ SO, apps, segurança", color: "#E8530A" },
    locacao: { text: "—", color: undefined },
    alt: false,
  },
  {
    label: "Monitoramento remoto",
    outsourcing: { text: "✓ 24/7 via RMM", color: "#E8530A" },
    locacao: { text: "—", color: undefined },
    alt: true,
  },
  {
    label: "Manutenção do equipamento",
    outsourcing: { text: "✓ Incluída", color: "#E8530A" },
    locacao: { text: "✓ Incluída", color: "#FF6B35" },
    alt: false,
  },
  {
    label: "Modelo de cobrança",
    outsourcing: { text: "Mensalidade por estação", color: "var(--text-primary)" },
    locacao: { text: "Mensalidade ou por página", color: "var(--text-primary)" },
    alt: true,
  },
];

const OUTSOURCING_PLANS = [
  {
    tag: "Essencial",
    title: "Entrada",
    desc: "Para pequenas empresas que precisam de equipamentos confiáveis com suporte básico.",
    features: [
      "PC ou notebook fornecido",
      "Sistema operacional licenciado",
      "Antivírus gerenciado",
      "Suporte remoto em horário comercial",
      "Substituição em caso de falha",
    ],
    ctaLabel: "Solicitar proposta",
    featured: false,
  },
  {
    tag: "Business",
    title: "Completo",
    desc: "Para empresas que querem TI totalmente gerenciada com monitoramento proativo.",
    features: [
      "Tudo do plano Essencial",
      "Monitoramento RMM 24/7",
      "Suporte remoto e presencial",
      "Gestão de atualizações e patches",
      "Relatório mensal de TI",
      "Backup gerenciado incluso",
    ],
    ctaLabel: "Solicitar proposta →",
    featured: true,
    badge: "Mais escolhido",
  },
  {
    tag: "Enterprise",
    title: "Personalizado",
    desc: "Para médias e grandes empresas com necessidades específicas de infraestrutura.",
    features: [
      "Tudo do plano Business",
      "SLA com tempo de resposta garantido",
      "Gerente de TI dedicado",
      "Integração com servidores e rede",
      "Contrato personalizado por volume",
    ],
    ctaLabel: "Falar com especialista",
    featured: false,
  },
];

const PRINTER_PLANS = [
  {
    tag: "Mono",
    title: "Preto & Branco",
    desc: "Ideal para escritórios com alto volume de documentos e relatórios em P&B.",
    features: [
      "Impressora laser monocromática",
      "Toner incluso na franquia",
      "Impressão, cópia e digitalização",
      "Instalação em rede incluída",
      "Manutenção preventiva inclusa",
    ],
    ctaLabel: "Solicitar proposta",
    featured: false,
  },
  {
    tag: "Color",
    title: "Colorida",
    desc: "Para empresas que precisam de impressões coloridas com qualidade profissional.",
    features: [
      "Impressora laser colorida multifuncional",
      "Toner colorido e P&B inclusos",
      "Impressão, cópia, digitalização e fax",
      "Relatório mensal de páginas impressas",
      "Manutenção preventiva e corretiva",
      "Substituição em caso de pane",
    ],
    ctaLabel: "Solicitar proposta →",
    featured: true,
    badge: "Mais escolhido",
  },
  {
    tag: "Frota",
    title: "Múltiplos andares",
    desc: "Para empresas com vários departamentos ou filiais que precisam de múltiplas impressoras.",
    features: [
      "2 ou mais equipamentos por contrato",
      "Mix de mono e colorida possível",
      "Gerenciamento centralizado",
      "Desconto por volume de equipamentos",
      "Atendimento prioritário no SLA",
    ],
    ctaLabel: "Falar com especialista",
    featured: false,
  },
];

function PlanCard({ plan, accent, delay = 0 }) {
  const cardStyle = plan.featured
    ? {
        "--accent": accent,
        padding: "36px",
        display: "flex",
        flexDirection: "column",
        background:
          accent === "#E8530A"
            ? "linear-gradient(135deg,rgba(232,83,10,.1),rgba(255,107,53,.04))"
            : "linear-gradient(135deg,rgba(255,107,53,.1),rgba(232,83,10,.04))",
        borderColor: `${accent}55`,
        position: "relative",
      }
    : {
        "--accent": accent,
        padding: "36px",
        display: "flex",
        flexDirection: "column",
      };

  return (
    <Reveal className="card" delay={delay} style={cardStyle}>
      {plan.featured && (
        <div
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            background: accent,
            color: "#fff",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: ".08em",
            padding: "4px 16px",
            borderRadius: "0 0 8px 8px",
            textTransform: "uppercase",
          }}
        >
          {plan.badge}
        </div>
      )}
      <div className="card__tag" style={{ color: accent, marginBottom: "16px" }}>
        {plan.tag}
      </div>
      <h3
        style={{
          fontFamily: "var(--font-display)",
          fontSize: "22px",
          fontWeight: 700,
          marginBottom: "8px",
          color: "var(--text-primary)",
        }}
      >
        {plan.title}
      </h3>
      <p
        style={{
          fontSize: "13px",
          color: "var(--text-muted)",
          marginBottom: "24px",
          lineHeight: "1.5",
        }}
      >
        {plan.desc}
      </p>
      <div
        style={{
          borderTop: "1px solid var(--bg-border)",
          paddingTop: "24px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {plan.features.map((feature) => (
          <div
            key={feature}
            style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}
          >
            <span style={{ color: accent, fontWeight: 700, flexShrink: 0 }}>
              ✓
            </span>
            <span style={{ fontSize: "13px", color: "var(--text-secondary)" }}>
              {feature}
            </span>
          </div>
        ))}
      </div>
      {plan.featured ? (
        <Link
          to="/contato"
          className="btn"
          style={{
            marginTop: "28px",
            textAlign: "center",
            justifyContent: "center",
            background: accent,
            color: "#fff",
            fontWeight: 700,
          }}
        >
          {plan.ctaLabel}
        </Link>
      ) : (
        <Link
          to="/contato"
          className="btn btn-outline"
          style={{
            marginTop: "28px",
            textAlign: "center",
            justifyContent: "center",
            borderColor: `${accent}66`,
            color: accent,
          }}
        >
          {plan.ctaLabel}
        </Link>
      )}
    </Reveal>
  );
}

export default function OutsourcingLocacao() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <Link to="/produtos/produtos">Produtos</Link>
            <span>/</span>
            <span>Outsourcing &amp; Locação</span>
          </div>
          <div className="tag animate-up animate-up--d1" style={{ color: "#E8530A", background: "rgba(232,83,10,.1)", borderColor: "rgba(232,83,10,.25)" }}>
            <IconPrinter style={{ width: "13px", height: "13px" }} />
            Outsourcing de TI · Locação de Impressoras
          </div>
          <h1
            className="animate-up animate-up--d2"
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "clamp(36px,6vw,68px)",
              fontWeight: 700,
              letterSpacing: "-.03em",
              lineHeight: "1.05",
              marginBottom: "24px",
              color: "var(--text-primary)",
            }}
          >
            Outsourcing <span style={{ color: "#E8530A" }}>&amp;</span> Locação
            <br />
            de Impressoras
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "560px",
              lineHeight: "1.7",
              marginBottom: "40px",
            }}
          >
            Terceirize sua infraestrutura de TI ou impressão com custo fixo
            mensal, sem surpresas. A sepolTECH cuida de tudo — equipamentos,
            manutenção e suporte — enquanto você foca no seu negócio.
          </p>
          <div className="hero-actions-col animate-up animate-up--d4">
            <Link to="/contato" className="btn btn-primary">
              Solicitar proposta →
            </Link>
            <Link to="/contato" className="btn btn-outline">
              Falar com especialista
            </Link>
          </div>
        </div>
      </section>

      {/* ═══════════════ DIFERENÇA ENTRE OS 2 SERVIÇOS ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="text-center" style={{ marginBottom: "56px" }}>
            <div className="tag" style={{ color: "#E8530A", background: "rgba(232,83,10,.1)", borderColor: "rgba(232,83,10,.25)" }}>
              Entenda a diferença
            </div>
            <h2 className="section-title">
              Dois serviços, uma só
              <br />
              <span style={{ color: "#E8530A" }}>tranquilidade</span>
            </h2>
            <p
              style={{
                color: "var(--text-secondary)",
                maxWidth: "560px",
                margin: "16px auto 0",
                lineHeight: "1.7",
              }}
            >
              Ambos funcionam no modelo de assinatura mensal com suporte
              incluso — mas atendem necessidades diferentes.
            </p>
          </Reveal>

          <div className="grid-2col-compare">
            {COMPARE_CARDS.map((card, i) => (
              <Reveal
                className="card"
                delay={i * 0.1}
                key={card.tag}
                style={{
                  "--accent": card.accent,
                  padding: "40px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "120px",
                    height: "120px",
                    background: `radial-gradient(circle at top right,${card.glow},transparent)`,
                    pointerEvents: "none",
                  }}
                ></div>
                <div
                  className="card__icon"
                  style={{ background: card.glow, color: card.accent, marginBottom: "20px" }}
                >
                  <card.Icon style={{ width: "26px", height: "26px" }} />
                </div>
                <div
                  className="card__tag"
                  style={{ color: card.accent, marginBottom: "12px" }}
                >
                  {card.tag}
                </div>
                <h3
                  style={{
                    fontFamily: "var(--font-display)",
                    fontSize: "26px",
                    fontWeight: 700,
                    marginBottom: "16px",
                    color: "var(--text-primary)",
                  }}
                >
                  {card.title}
                </h3>
                <p
                  style={{
                    color: "var(--text-secondary)",
                    lineHeight: "1.7",
                    marginBottom: "24px",
                  }}
                >
                  {card.desc}
                </p>
                <div
                  style={{
                    borderTop: "1px solid var(--bg-border)",
                    paddingTop: "24px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {card.bullets.map((bullet) => (
                    <div
                      key={bullet.title}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          width: "22px",
                          height: "22px",
                          background: card.glow,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: card.accent,
                          fontSize: "12px",
                          flexShrink: 0,
                          marginTop: "2px",
                        }}
                      >
                        ✓
                      </div>
                      <span
                        style={{
                          color: "var(--text-secondary)",
                          fontSize: "14px",
                          lineHeight: "1.5",
                        }}
                      >
                        <strong style={{ color: "var(--text-primary)" }}>
                          {bullet.title}
                        </strong>{" "}
                        — {bullet.desc}
                      </span>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    marginTop: "28px",
                    padding: "16px",
                    background: `${card.accent}14`,
                    borderRadius: "var(--radius-md)",
                    border: `1px solid ${card.accent}33`,
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "var(--text-secondary)",
                      lineHeight: "1.5",
                      margin: 0,
                    }}
                  >
                    <strong style={{ color: card.accent }}>Ideal para:</strong>{" "}
                    {card.note}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>

          {/* Tabela comparativa rápida */}
          <Reveal
            delay={0.15}
            style={{
              marginTop: "48px",
              background: "var(--bg-card)",
              border: "1px solid var(--bg-border)",
              borderRadius: "var(--radius-lg)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "24px 32px",
                borderBottom: "1px solid var(--bg-border)",
              }}
            >
              <h3
                style={{
                  fontFamily: "var(--font-display)",
                  fontSize: "18px",
                  fontWeight: 700,
                  margin: 0,
                  color: "var(--text-primary)",
                }}
              >
                Comparativo rápido
              </h3>
            </div>
            <div className="table-scroll">
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px",
                }}
              >
                <thead>
                  <tr style={{ background: "var(--bg-card-hover)" }}>
                    <th
                      style={{
                        padding: "16px 32px",
                        textAlign: "left",
                        color: "var(--text-muted)",
                        fontWeight: 600,
                        borderBottom: "1px solid var(--bg-border)",
                      }}
                    >
                      Característica
                    </th>
                    <th
                      style={{
                        padding: "16px 24px",
                        textAlign: "center",
                        color: "#E8530A",
                        fontWeight: 700,
                        borderBottom: "1px solid var(--bg-border)",
                      }}
                    >
                      <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                        <IconMonitor style={{ width: "15px", height: "15px" }} />
                        Outsourcing de TI
                      </span>
                    </th>
                    <th
                      style={{
                        padding: "16px 24px",
                        textAlign: "center",
                        color: "#FF6B35",
                        fontWeight: 700,
                        borderBottom: "1px solid var(--bg-border)",
                      }}
                    >
                      <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                        <IconPrinter style={{ width: "15px", height: "15px" }} />
                        Locação de Impressoras
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {TABLE_ROWS.map((row) => (
                    <tr
                      key={row.label}
                      style={{
                        borderBottom: "1px solid var(--bg-border)",
                        background: row.alt ? "rgba(15,23,42,.02)" : undefined,
                      }}
                    >
                      <td style={{ padding: "14px 32px", color: "var(--text-secondary)" }}>
                        {row.label}
                      </td>
                      <td
                        style={{
                          padding: "14px 24px",
                          textAlign: "center",
                          color: row.outsourcing.color,
                        }}
                      >
                        {row.outsourcing.text}
                      </td>
                      <td
                        style={{
                          padding: "14px 24px",
                          textAlign: "center",
                          color: row.locacao.color,
                        }}
                      >
                        {row.locacao.text}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td style={{ padding: "14px 32px", color: "var(--text-secondary)" }}>
                      Podem ser combinados?
                    </td>
                    <td
                      colSpan={2}
                      style={{
                        padding: "14px 24px",
                        textAlign: "center",
                        color: "#E8530A",
                        fontWeight: 700,
                      }}
                    >
                      ✓ Sim — contrate os dois com desconto
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ═══════════════ PLANOS OUTSOURCING ═══════════════ */}
      <section className="section section--alt">
        <div className="container">
          <Reveal className="text-center" style={{ marginBottom: "48px" }}>
            <div className="tag" style={{ color: "#E8530A", background: "rgba(232,83,10,.1)", borderColor: "rgba(232,83,10,.25)" }}>
              Outsourcing de TI
            </div>
            <h2 className="section-title">
              Planos de <span style={{ color: "#E8530A" }}>Outsourcing</span>
            </h2>
            <p
              style={{
                color: "var(--text-secondary)",
                maxWidth: "500px",
                margin: "16px auto 0",
              }}
            >
              Por estação de trabalho/mês. Quanto mais estações, menor o
              valor unitário.
            </p>
          </Reveal>

          <div className="grid-3col-plans">
            {OUTSOURCING_PLANS.map((plan, i) => (
              <PlanCard plan={plan} accent="#E8530A" delay={i * 0.08} key={plan.tag} />
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ PLANOS LOCAÇÃO IMPRESSORA ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="text-center" style={{ marginBottom: "48px" }}>
            <div className="tag" style={{ color: "#FF6B35", background: "rgba(255,107,53,.1)", borderColor: "rgba(255,107,53,.25)" }}>
              Locação de Impressoras
            </div>
            <h2 className="section-title">
              Planos de <span style={{ color: "#FF6B35" }}>Locação</span>
            </h2>
            <p
              style={{
                color: "var(--text-secondary)",
                maxWidth: "500px",
                margin: "16px auto 0",
              }}
            >
              Toner, manutenção e suporte incluídos. Você só imprime — a
              sepolTECH cuida do resto.
            </p>
          </Reveal>

          <div className="grid-3col-plans">
            {PRINTER_PLANS.map((plan, i) => (
              <PlanCard plan={plan} accent="#FF6B35" delay={i * 0.08} key={plan.tag} />
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ FAQ ═══════════════ */}
      <section className="section section--alt">
        <div className="container" style={{ maxWidth: "760px" }}>
          <Reveal className="text-center" style={{ marginBottom: "40px" }}>
            <div className="tag" style={{ color: "#E8530A", background: "rgba(232,83,10,.1)", borderColor: "rgba(232,83,10,.25)" }}>
              Dúvidas frequentes
            </div>
            <h2 className="section-title">
              Perguntas sobre{" "}
              <span style={{ color: "#E8530A" }}>Outsourcing &amp; Locação</span>
            </h2>
          </Reveal>

          {FAQS.map((faq, index) => (
            <Reveal
              className={`faq-item${openFaq === index ? " open" : ""}`}
              delay={index * 0.04}
              key={faq.question}
            >
              <button
                className="faq-btn"
                onClick={() => toggleFaq(index)}
                aria-expanded={openFaq === index}
              >
                {faq.question}
                <span className="faq-btn__icon">+</span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="cta-banner">
            <h2 className="cta-banner__title">
              Pronto para terceirizar
              <br />
              sua TI e impressão?
            </h2>
            <p className="cta-banner__sub">
              Solicite uma proposta personalizada. Nosso time avalia sua
              empresa e monta o plano ideal.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Solicitar proposta →
              </Link>
              <Link to="/produtos/produtos" className="btn btn-outline">
                Ver outros produtos
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
